// extracted by mini-css-extract-plugin
module.exports = {"time":"date-time_time_2K98x"};